export default __webpack_public_path__ + "static/media/IMG_0260.8d3ceaa0.8d3ceaa0.JPG";